export class User {
	email: string;
	first_name: string;
	last_name: string;
	id: string;
}
